import { useContext } from 'react';
import ContentContext from './content-context';

export default () => {
  const { content } = useContext<any>(ContentContext);
  return [content];
};
